import { estudianteTypes } from "../../types/estudianteTypes"

export const valida_DNI = ( payload ) => ({
    type: estudianteTypes.ESTUDIANTE_SAVE_START,
    payload
})

export const resetValidacion = ( payload = [] ) => ({
    type: estudianteTypes.ESTUDIANTE_VALIDATED,
    payload
})

export const setExisteObservacion = ( payload ) => ({
    type: estudianteTypes.ESTUDIANTE_SET_OBSERVACION,
    payload
})

export const obtiene_formatos = ( payload ) => ({
    type: estudianteTypes.ESTUDIANTE_GET_FORMATOS,
    payload
})

export const valida_Beneficiario = ( payload ) => ({
    type: estudianteTypes.ESTUDIANTE_SAVE_START,
    payload
})

export const updateDato = ( payload ) => ({
    type: estudianteTypes.ESTUDIANTE_UPDATED,
    payload
})
